import template from "./entity-users.html";
import "./entity-users.less";
import { FORM_ENTITY_USERS } from "routes.js";

export function controller(
	appState,
	api,
	loadingService,
	$logger,
	$uibModal
) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	ctrl.edit = edit;

	function onInit() {
		ctrl.form = appState.forms.selected;

		loadRelatedUsers();
	}

	function loadRelatedUsers() {
		const promise = api.get(FORM_ENTITY_USERS(appState.forms.selected.Id, ctrl.entity.Id)).then((response) => {
			ctrl.users = response;
		});

		loadingService.watch(promise);
	}

	function edit(user) {
		$uibModal.open({
			component: "user-modal",
			size: "xlg",
			resolve: {
				user: () => user,
				syncUrl: () => false
			},
			getUsers: () => undefined
		}).result.then(() => {

		});
	}
}

export default angular
	.module("vesl.components.entity-users", [])
	.component("entityUsers", {
		controller,
		template,
		bindings: {
			entity: "<"
		}
	}).name;
